export default "__VITE_ASSET__FXLg$e6g__ 820w, __VITE_ASSET__VpvpCaZW__ 500w";